"use client";

export { default } from "./StudioScreenRenderer.component";
export type { StudioScreenRendererProps } from "./StudioScreenRenderer.props";